import React from 'react';
export function Footer() {
  return <footer className="bg-primary-dark py-12 px-4 border-t-4 border-gold text-center" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <h2 className="text-2xl md:text-3xl font-bold text-gold mb-4 font-serif" data-id="element-99">
          💰 BIBLIOTECADIGITAL.ONLINE™
        </h2>
        <p className="text-cream/90 text-base md:text-lg mb-2 font-medium" data-id="element-100">
          El sistema de finanzas personales N°1 para argentinos que quieren
          dejar de improvisar con su plata.
        </p>
        <p className="text-gold/80 italic mb-8 font-serif text-lg" data-id="element-101">
          Porque controlar tu dinero no debería costarte años de prueba y error.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-cream/70 text-sm mb-8 font-medium bg-black/20 py-3 px-6 rounded-full inline-flex border border-white/10" data-id="element-102">
          <span data-id="element-103">📧 soportebibliodigital@gmail.com</span>
          <span className="hidden md:inline text-gold" data-id="element-104">•</span>
          <span data-id="element-105">🌐 www.digitalbibliotec.online</span>
        </div>

        <p className="text-cream/40 text-xs mb-8" data-id="element-106">
          © BibliotecaDigital.online™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-xl md:text-2xl italic text-gold font-bold font-serif" data-id="element-107">
          "Tu dinero tiene un destino. La diferencia es si lo elegís vos o lo
          elige el sistema." 💰
        </p>
      </div>
    </footer>;
}